import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { CertificationAdminApiService } from '@api/certification-admin/certification-admin.api.service';
import { ENV, Env } from '@providers/env.provider';
import { CertificationAdminSession } from 'types/CertificationAdmin';

@Injectable()
export class CertificationAdminRepository {
  public constructor(
    private readonly api: CertificationAdminApiService,
    @Inject(ENV) private readonly env: Env,
  ) {}

  public createSession(): Observable<CertificationAdminSession> {
    const apiUrl = this.env()?.certificationAdminApiUrl;
    if (!apiUrl) {
      return throwError(() => new Error('Certification admin API is not configured'));
    }
    return this.api.createSession(apiUrl);
  }
}
